// NPM imports
import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';


import Layout from '../../components/Layout';
import FlightChange from '../flight-change';
import FlightConfirmation from '../flight-confirmation';
import FlightIntroduction from '../flight-introduction';

// Component

class Logged extends Component {

  render() {
    const {
      match,
      user,
      flights,
      hasSuggestion,
    } = this.props;
    return (
      <Layout>
        <Switch>
          <Route
            exact
            path={`${match.url}/flight-introduction`}
            component={FlightIntroduction}
            hasSuggestion={hasSuggestion}
          />
          <Route
            exact
            path={`${match.url}/flight-change`}
            render={(routerProps) => (
              <FlightChange
                {...routerProps}
                user={user}
                flights={flights}
              />
            )}
          />
          <Route
            exact
            path={`${match.url}/flight-confirmation`}
            component={FlightConfirmation}
          />
        </Switch>
      </Layout>
    );
  }
}

export default Logged;
